import React from "react";
import "./SkillsCard.css";

const SkillsCard = ({title, iconURL, isActive, onClick}) => {

    return (
        <div
        className={`skills-card ${isActive ? "active": ""}`}
        onClick={() =>onClick()}
        >
           
           <div className="skills-icon">
            <img src={iconURL} alt={title}/>
           </div>

           <span>{title}</span>
        </div>
    );
}

export default SkillsCard;